<script>
  export let index;
  export let imagen;
  export let descripcion;
  export let last;

  import { openDocument } from "../utils/openDocument";

  import { dictionary } from "../utils/stores.js";

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });
</script>

<style>
  div.articleFigureItem {
    display: flex;
    width: 100%;
    color: var(--revista-black) !important;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  div.last {
    margin-bottom: 0px;
  }

  div.imageIcon {
    margin-right: 20px;
  }

  div.imageIcon img {
    width: 50px;
  }

  div.description {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  div.options {
    display: flex;
  }

  div.options img {
    width: 20px;
    height: 20px;
    margin-left: 5px;
  }

  img.imgButton {
    cursor: pointer;
  }

  span.figura {
    font-weight: bold;
  }
</style>

<div class="articleFigureItem {last ? 'last' : ''}">
  <div class="imageIcon">
    {#if imagen}
      <a href="#" onclick="return false;" on:click={() => openDocument(imagen)}>
        <img src={imagen} alt="Figure Image" />
      </a>
    {:else}
      <img src={'/images/revista/picture.svg'} alt="Figure Image" />
    {/if}
  </div>
  <div class="description">
    <span class="figura">{dict['figura']} {index + 1}.</span>
    {descripcion}
  </div>
  <div class="options">
    {#if imagen}
      <a href="#" onclick="return false;" on:click={() => openDocument(imagen)}>
        <img
          class="imgButton"
          src="/images/revista/download.svg"
          alt="View Icon" />
      </a>
    {/if}
  </div>
</div>
